












































































































import { Vue, Component } from 'vue-property-decorator'
import PStorage, { USERNAME, EMAIL, storeKeys } from '@/util/PStorage'
import SettingsAPI from '@/util/api/SettingsAPI'
import { ResponseStatus } from '@/enum'
import { Nullable } from '@/types/general'
import OnboardingAPI from '@/util/api/OnboardingAPI'

import SettingsHeader from '../components/SettingsHeader.vue'
import SettingsSection from '../components/SettingsSection.vue'
import SettingsRow from '../components/SettingsRow.vue'

/* eslint-disable indent */
@Component({
    name: 'account-panel',
    components: { SettingsHeader, SettingsSection, SettingsRow }
})
/* eslint-enable indent */
export default class AccountPanel extends Vue {
    initialDisplayName: string = PStorage.get(USERNAME)
    displayName: string = PStorage.get(USERNAME)
    displayNameError: Nullable<string> = null

    initialEmail: string = PStorage.get(EMAIL)
    email: string = PStorage.get(EMAIL)
    emailError: Nullable<string> = null

    async resetAuth(): Promise<void> {
        await OnboardingAPI.revokeTokens()
        this.$success({ text: 'Revoked all sessions successfully.' })
    }

    /**
     * Clear all app storage and logout
     */
    forgetMe(): void {
        storeKeys.forEach((key: string) => PStorage.remove(key))
        this.$router.push('/register')
    }

    /**
     * Try to update the user's display name / username
     */
    async updateDisplayName(): Promise<void> {
        const response = await SettingsAPI.updateUsername(this.displayName)
        if (response.status === ResponseStatus.SUCCESS) {
            PStorage.set('username', this.displayName)
            this.initialDisplayName = this.displayName
        } else {
            this.emailError = response.message || null
        }
    }

    /**
     * Try to update the user's email address.
     *
     * Can fail if the address is already in use or is invalid
     */
    async updateEmail(): Promise<void> {
        const response = await SettingsAPI.updateEmail(this.email)
        if (response.status === ResponseStatus.SUCCESS) {
            PStorage.set('email', this.email)
            this.initialEmail = this.email
        } else {
            this.emailError = response.message || null
        }
    }
}
